module.exports = __webpack_public_path__ + "img/task1_icon1.28d51357.png";